<template>
  <b-container class="contendordepagina">
    <loading :active.sync="isEnviando" :is-full-page="true"></loading>
    <AlertaError v-if="mensajeerror.length" :mensajeerror="mensajeerror" v-on:cerrado="onAlertErrorCerrado"></AlertaError>

    <div v-if="paso == 1">
      <SeleccionFirmantes tituloh1="Paso 1 de 4. Indica qué personas firmarán el documento" :firmantespredefinidos="miembrosconsejoadministracion" v-on:paso-atras="onPasoAtras" v-on:firmantes-seleccionados="onFirmantesSeleccionados"> </SeleccionFirmantes>
    </div>
    <div v-if="paso == 2">
      <SubirPDFaFirmar tituloh1="Paso 2 de 4. Sube el PDF del documento que se va a enviar a firmar por via electrónica" :tipologia="tipologia" :seleccionartipologia="false" :descripcion="descripcion" :indicardescripcion="true" seccionactiva="ESPECIALES-CONSEJOADM" v-on:paso-atras="onPasoAtras" v-on:pdf-subido="onPDFSubido"> </SubirPDFaFirmar>
    </div>
    <div v-if="paso == 3">
      <DefinicionCaracteristicasDeFirmantes tituloh1="Paso 3 de 4. Características de la firma" :firmantes="datosdocumento.firmantes" :pdfdoc="pdfdocumento" :ubicacionfirmas="ubicacionfirmas" v-on:paso-atras="onPasoAtras" v-on:atributos-firmantes-definidos="onAtributosFirmatesDefinidos"> </DefinicionCaracteristicasDeFirmantes>
    </div>
    <div v-if="paso == 4">
      <ConfirmacionDelEnvio tituloh1="Paso 4 de 4. Confirmación del envío" :datosdocumento="datosdocumento" v-on:paso-atras="onPasoAtras" v-on:envio-confirmado="onEnvioConfirmado"></ConfirmacionDelEnvio>
    </div>
    <div v-if="paso == 5">
      <ResultadoDelEnvio :datosdocumento="datosdocumento" :resultadoefirma="resultadoefirma"></ResultadoDelEnvio>
    </div>
  </b-container>
</template>

<script>
import AlertaError from '@/components/AlertaError.vue';
import SeleccionFirmantes from '@/components/SeleccionFirmantes.vue';
import SubirPDFaFirmar from '@/components/SubirPDFaFirmar.vue';
import DefinicionCaracteristicasDeFirmantes from '@/components/DefinicionCaracteristicasDeFirmantes.vue';
import ConfirmacionDelEnvio from '@/components/ConfirmacionDelEnvio.vue';
import ResultadoDelEnvio from '@/components/ResultadoDelEnvio.vue';
import Loading from 'vue-loading-overlay';

import { mapState } from 'vuex';

export default {
  components: {
    AlertaError,
    SeleccionFirmantes,
    SubirPDFaFirmar,
    DefinicionCaracteristicasDeFirmantes,
    ConfirmacionDelEnvio,
    ResultadoDelEnvio,
    Loading
  },
  data() {
    return {
      mensajeerror: '',
      paso: 0,
      datosdocumento: null,
      pdfdocumento: '',
      ubicacionfirmas: 'ultimapagina',
      envioconfirmado: false,
      isEnviando: false,
      tipologia: 'CJACERTIFICADO',
      descripcion: 'Certificado - ' + this.$moment().format('LL'),
      fechahoy: this.$moment().format('LL'),
      codigoempresa: '',
      resultadoefirma: null,
      miembrosconsejoadministracion: null
    };
  },
  mounted() {
    this.$store.commit('SET_SECCION', 'Documentación Consejo Administración');
    this.inicializar();
  },
  methods: {
    inicializar: function () {
      const url = '/api/489e939af6e943c2b9324fc27d16256816cce60abe0b4e0db95b0054a591eca89e627a37400a4feba8ba94b8763cc295/efirma/accion';
      var _t = this;
      this.axios
        .get('efirma/get-firmantes-consejo-administracion', {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.usuario_token}`
          }
        })
        .then(function (response) {
          console.log('inicializar', response.data);
          _t.miembrosconsejoadministracion = response.data;
          _t.paso = 1;
        });
    },
    onFirmantesSeleccionados: function (firmantes) {
      this.activarefirma(firmantes); // con los firmantes obtenidos, se activa la efirma
    },
    activarefirma: function (firmantes) {
      const url = '/api/489e939af6e943c2b9324fc27d16256816cce60abe0b4e0db95b0054a591eca89e627a37400a4feba8ba94b8763cc295/efirma/accion';
      // Los firmantes los damos por ya definidos
      const params = {
        firmantes: firmantes,
        descripcion: this.descripcion,
        validadopor: this.usuario_email
      };

      this.isEnviando = true;
      // Se envía el email personalizado mediante API con un método específico, que genera dos PDF: hoja de validación y borrador contrato
      var _t = this;
      this.axios
        .post('efirma/activar-efirma-estandar', params, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.usuario_token}`
          }
        })
        .then(function (response) {
          if (response.data.error === '') {
            console.log('activar-efirma-estandar', response.data.datosdocumento);
            _t.datosdocumento = response.data.datosdocumento;
            _t.datosdocumento.firmantes.forEach((f) => {
              f.piefirma.activado = true;
              f.posicionfirma.definida = true;
              f.efirmadefinida = true;
            });
            _t.paso++;
          } else {
            _t.mensajeerror = 'ERROR: ' + response.data.error;
          }
        })
        .catch(function (error) {
          console.log('activar-efirma-estandar - error', error);
          _t.mensajeerror = 'Error 1020. No se pudo iniciar el proceso.<br />' + error;
        })
        .then(function () {
          _t.isEnviando = false;
        });
    },
    //Ejemplo de uso: console.log("Certificado De MDS", this.certificadosegunmodoysello("cdsegunsello", "selloMDS"))
    certificadosegunmodoysello: function (modofirma, selloempresa) {
      if (modofirma === 'cdsegunsello') {
        const mcde = this.$store.getters.misCertificadosDeEmpresa.filter((c) => c.sello === selloempresa)[0];
        return mcde.certificado;
      }
      return '';
    },
    onAlertErrorCerrado: function () {
      this.mensajeerror = '';
    },
    onPasoAtras: function () {
      switch (this.paso) {
        case 2:
          this.pdfdocumento = null;
          break;
      }
      this.paso--;
    },
    /**
     * @description Proviene de SubirPDFaFirmar.
     *    Devuelve el contenido (base64) del PDF que se enviará a firmar, con el fin de disponer de él para poderlo visualizar
     */
    onPDFSubido: function (contenidopdf, tipologia, descripcion) {
      //console.log("pdfsubido", pdfsubido)
      this.pdfdocumento = contenidopdf;
      this.datosdocumento.tipologia = tipologia;
      this.datosdocumento.descripcion = descripcion;
      this.paso++;
    },
    /**
     * @description Proviene de DefinicionCaracteristicasDeFirmantes.
     *    Devuelve, de cada firmante, la definición final de los atributos de cada firma
     */
    onAtributosFirmatesDefinidos: function (ubicacionfirmas, atributosfirmantes) {
      this.datosdocumento.ubicacionfirmas = ubicacionfirmas;
      this.datosdocumento.firmantes = atributosfirmantes;
      console.log('onAtributosFirmatesDefinidos', this.datosdocumento);
      this.paso++;
    },
    /**
     * @description Proviene de ConfirmacionDelEnvio.
     *    Devuelve el cuerpo del mensaje que se enviará al firmante de Manusa
     */
    onEnvioConfirmado: function () {
      const url = '/api/489e939af6e943c2b9324fc27d16256816cce60abe0b4e0db95b0054a591eca89e627a37400a4feba8ba94b8763cc295/efirma/accion';
      this.envioconfirmado = true;

      console.log('onEnvioConfirmado', this.datosdocumento);
      var _t = this;
      const params = {
        datapdf: this.pdfdocumento,
        atributosfirmantes: this.datosdocumento.firmantes,
        modoborrador: false
      };
      this.axios
        .post('efirma/procesar-pdf-segun-firmantes-' + this.datosdocumento.ubicacionfirmas, params, {
          headers: {
            Authorization: `Bearer ${process.env.VUE_APP_CLAVEAPIEFIRMA}`
          }
        })
        .then(function (response) {
          _t.iniciarProcesoDeFirma(response.data.srcpdfprocesado);
        });
    },
    /**
     * @description Envía la orden a la API para dar inicio al proceso de efirma del contrato, compuesta por:
     *              - Envío de orden de firma electrónica a Signaturit del contrato procesado
     *              Una vez finalizado, se muestra el resultado de la operación (en el siguiente paso)
     */
    iniciarProcesoDeFirma: function (pdfparafirmar) {
      var firmantes = [];
      var cuerpodelcorreo = "Se solicita a los asistentes a la reunión del Comité de trabajadores, la firma del documento '" + this.datosdocumento.descripcion + "').\nPara llevar a cabo la firma electrónica del mismo, se ruega se sigan las instrucciones indicadas.\nAtentamente,\n";

      this.datosdocumento.firmantes.forEach((f) => {
        firmantes.push({
          id: f.id,
          mensajeprivado: '',
          nombre: f.nombre,
          email: f.email,
          modofirma: f.modofirma,
          digital_certificate_name: this.certificadosegunmodoysello(f.modofirma, f.selloempresa)
        });
      });
      const params = {
        nombrefichero: this.datosdocumento.codigo + '.pdf',
        datapdf: pdfparafirmar,
        remitente: {
          nombre: this.usuario_nombre,
          email: this.usuario_email
        },
        cc: [
          {
            nombre: this.usuario_nombre,
            email: this.usuario_email
          }
        ],
        numerofirmantes: firmantes.length,
        firmantes: firmantes,
        emailfirmantes: {
          asunto: 'Firma de Certificado',
          cuerpo: cuerpodelcorreo
        },
        signing_mode: 'parallel',
        data: {
          titulo: this.datosdocumento.descripcion,
          tipologia_codigo: this.datosdocumento.tipologia,
          tipologia_descripcion: this.$store.getters.misTipologiasDeEFirma.filter((c) => c.codigo === this.datosdocumento.tipologia)[0].descripcion,
          departamento: this.$store.getters.misTipologiasDeEFirma.filter((c) => c.codigo === this.datosdocumento.tipologia)[0].departamento
        },
        modoapp: this.$store.getters.miModoApp
      };
      console.log(params);
      this.isEnviando = true;
      const url = '/api/489e939af6e943c2b9324fc27d16256816cce60abe0b4e0db95b0054a591eca89e627a37400a4feba8ba94b8763cc295/efirma/accion';
      // Se envía el email personalizado mediante API con un método específico, que genera dos PDF: hoja de validación y borrador contrato
      var _t = this;
      this.axios
        .post('efirma/enviar-documento-a-firmar', params, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.usuario_token}`
          }
        })
        .then(function (response) {
          console.log('enviar-documento-a-firmar', response);
          if (response.data.error === '') {
            // se da por concluido el envío y se informa del resultado
            _t.datosdocumento.procesoefirma = {
              enviadaaefirmantes: true,
              estadoefirma: 'PENDIENTE'
            };
            _t.resultadoefirma = response.data.signaturit;
            _t.paso++;
          } else {
            _t.mensajeerror = 'ERROR: ' + response.data.error;
          }
        })
        .catch(function (error) {
          console.log('enviar-documento-a-firmar - error', error);
          _t.mensajeerror = 'Error 1002. No se pudo enviar el documento a firmar por Signaturit.<br />' + error;
        })
        .then(function () {
          _t.isEnviando = false;
        });
    }
  },
  watch: {},
  computed: {
    ...mapState(['user']),
    usuario_nombre: {
      get() {
        if (!this.user) return '';
        console.log('get', this.user);
        return this.user.nombre;
      }
    },
    usuario_token: {
      get() {
        if (!this.user) return '';
        return this.user.token;
      }
    },
    usuario_email: {
      get() {
        if (!this.user) return '';
        return this.user.email;
      }
    }
  }
};
</script>

<style scoped></style>
